import { FaPhoneAlt } from 'react-icons/fa';
import { CRUISE_PHONE_DISPLAY, CRUISE_PHONE_TEL } from '../../constants/contact';

export default function CruiseFixedCallBar() {
  return (
    <div className="cruise-fixed-call-bar" role="region" aria-label="Call cruise experts 24/7">
      <a href={`tel:${CRUISE_PHONE_TEL}`} className="cruise-fixed-call-bar__link">
        <FaPhoneAlt aria-hidden />
        <span className="cruise-fixed-call-bar__label">Call cruise experts — 24/7</span>
        <span className="cruise-fixed-call-bar__number">{CRUISE_PHONE_DISPLAY}</span>
      </a>
    </div>
  );
}
